jQuery(function ($) {

    $('.nav-collapse ul li .sub-menu-wrap').each(function() {
        var parent_id = $( this ).parent().attr('id');
        $('.megamenu-container').append('<div id="sub-' + parent_id + '" class="sub-menu-container">' + $( this ).html() + '<hr class="clear" /></div>')
    });

    $('.nav-collapse ul li').hover(function() {

        var elem_name = '#sub-' + $(this).attr('id');

        if ($(window).width() > (991 - 15)) {
              $( elem_name ).show();
        }

    }, function() {

        var elem_name = '#sub-' + $( this ).attr('id');

        $( elem_name ).hide();

    });

    $('.megamenu-container .sub-menu-container').hover(function() {

        if ($(window).width() > (991 - 15)) {
            $( this ).show();
        }

    }, function() {

        $( this ).hide();

    });

    $('.tarkempi-kuvaus-container .lue-lisaa').on('click', function() {
      $(this).siblings('.tarkempi-kuvaus').toggle();
    });



    /*global FWP:true*/
      /* exported FWP */
      $(document).on('facetwp-loaded', function() {
        var querystring = FWP.build_query_string();
        if ( '' === querystring ) { // no facets are selected
            $('.facet-reset').hide();
        }
        else {
            $('.facet-reset').show();
        }
      });

    /*$('.linked-products-container .woocommerce-LoopProduct-link').on('click', function(e) {
      e.preventDefault();
    }); */


    $(document).on('click', '.yith-wcqv-view-details', function () {
      $(this).attr('target', '_blank');
    });

    $('.categories .children').parent().addClass('parent');
  $('.categories .children').parent().prepend('<div class="cat-icon"><svg width="28" height="28" viewBox="0 0 28 28"><path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#000723"/></svg></div>');

  $('.cat-icon').on('click', function(){
    $(this).toggleClass('rotateicon');
    $(this).nextAll('.children').slideToggle();
    // $(this).find('svg path').attr('d');
  });

  $('.current-cat .cat-icon').addClass('rotateicon');
  //$('.current-cat-parent .cat-icon').addClass('rotateicon');
  $('.current-cat-ancestor > .cat-icon').addClass('rotateicon');


  $( ".toggle-button" ).click(function() {
    $(".toggle-button").toggleClass("is-active");
    $( ".categories-body" ).slideToggle( "fast", function() {
    });
  });

  $("#cookiebot").attr("href", "javascript:Cookiebot.renew()");

  if ($('body.product-template-default').length > 0) {

  $('.qty').appendTo('.product-quantity');
  $('.quantity').appendTo('.product-quantity');
  }


  if ($('body').hasClass('tax-woo-feed-brand')) {
    $('.woocommerce-breadcrumb').html($('.woocommerce-breadcrumb').html().replace('Brand by CTX Feed','Tuotemerkki'));
  }

  $('.trustbox__row').slick({
    infinite: true,
    arrows: true,
    speed: 1000,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    pauseonHover: true,
    focusOnSelect: true,
    swipeToSlide: true,
    prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'></button>"
  });

});
